export const convertTimeDuration = (DurationInMS) => {
  const hours = Math.floor(DurationInMS / 3600000);
  const minutes = Math.floor((DurationInMS % 3600000) / 60000);
  const seconds = Math.floor((DurationInMS % 60000) / 1000);
  const timeArr = [];
  if (hours > 0) {
    timeArr.push(`${hours < 10 ? '0' : ''}${hours}`);
  }
  timeArr.push(`${minutes < 10 ? '0' : ''}${minutes}`);
  timeArr.push(`${seconds < 10 ? '0' : ''}${seconds}`);
  return timeArr.join(':');
};
